module.exports = __webpack_public_path__ + "static/media/des-icon-3.ff554661.svg";